export default "__VITE_ASSET__CBV$ssXW__"